import { render, staticRenderFns } from "./SchoolCarousel.vue?vue&type=template&id=b80c9c30&scoped=true&"
import script from "./SchoolCarousel.vue?vue&type=script&lang=js&"
export * from "./SchoolCarousel.vue?vue&type=script&lang=js&"
import style0 from "./SchoolCarousel.vue?vue&type=style&index=0&id=b80c9c30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80c9c30",
  null
  
)

export default component.exports